module.exports = __webpack_public_path__ + "img/imagenhir1.341e2db8.jpg";